import { render } from "./Comments.vue?vue&type=template&id=83a8c85a&scoped=true&lang=pug"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=83a8c85a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a8c85a"]])

export default __exports__